import { render, staticRenderFns } from "./DomainSuspension.vue?vue&type=template&id=7c275121&scoped=true&"
import script from "./DomainSuspension.vue?vue&type=script&lang=js&"
export * from "./DomainSuspension.vue?vue&type=script&lang=js&"
import style0 from "./DomainSuspension.vue?vue&type=style&index=0&id=7c275121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c275121",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VLabel,VSelect,VSwitch})
